import { ExcelSheetName } from "@app/shared/constants";

export const ManualExcelImportSheetList = [
  {
    index: 0,
    sheetName: ExcelSheetName.DRIVER_OBSERVATION
  },
  {
    index: 1,
    sheetName: ExcelSheetName.EVCR_COMPLIANCE
  },
  {
    index: 2,
    sheetName: ExcelSheetName.APT_COMPLIANCE
  },
  {
    index: 3,
    sheetName: ExcelSheetName.SAFETY_MEETING_COMPLIANCE
  },
  {
    index: 4,
    sheetName: ExcelSheetName.AWARD
  }
]

export const GetExcelImportSheetNames = () => ManualExcelImportSheetList.map(item => item.sheetName);

export const GetIndexBySheetName = (sheetName: string) => ManualExcelImportSheetList.filter(item => item.sheetName === sheetName)[0].index;
